import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import CloseIcon from 'components/atoms/icons/closeIcon';
import SuccessfullyDoneIcon from 'components/atoms/icons/successfullyDoneIcon';

const SuccessPopup = ({ isOpen, toggle, children, ...rest }) => {
  const modalToggle = () => toggle(!isOpen);

  const closeButton = (
    <button className="close" onClick={modalToggle}>
      <CloseIcon />
    </button>
  );

  return (
    <Modal
      isOpen={isOpen}
      className="success-popup"
      toggle={modalToggle}
      backdropClassName="success-popup-backdrop"
      {...rest}
    >
      <ModalHeader toggle={modalToggle} close={closeButton} />
      <ModalBody>
        <SuccessfullyDoneIcon />
        <h6 className="success-popup__title">Success</h6>
        <div className="success-popup__description">
          Your changes have been successfully saved!
        </div>
      </ModalBody>
    </Modal>
  );
};

SuccessPopup.defaultProps = {
  isOpen: false,
};

SuccessPopup.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  children: PropTypes.object,
};

export default SuccessPopup;
